import LoadingIcon from '@svg/progress-activity.svg';
import PropTypes from 'prop-types';

import styles from './Loader.module.scss';

export default function Loader({
  title = 'Een momentje geduld.',
  message = 'Een momentje geduld alsjeblieft, we zijn bezig met verwerken.',
  loading,
  progress,
  stage,
}) {
  return (
    <div className={styles.loadingContainer} hidden={!loading}>
      <h3>{title}</h3>
      <p>{message}</p>
      <div className={styles.progressContainer}>
        <h4 className={styles.progressState}>
          {stage}
          <LoadingIcon className={styles.loadingIcon} />
        </h4>
        <span
          className={styles.progressBar}
          style={{ '--progress': `${progress}%` }}
        />
      </div>
    </div>
  );
}

Loader.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  stage: PropTypes.string,
  loading: PropTypes.bool,
  progress: PropTypes.number,
};
